module.exports = __webpack_public_path__ + "img/LogoDashboard-31.7c47408d.svg";